import React, {forwardRef, useImperativeHandle, useState} from 'react';
import CollapsibleSwitchFilterProps, { Switcher } from "./props";
import style from "./style.module.scss";
import classNames from '../../../utils/classNames';
import InputGroup from '../../private/InputGroup';
import inputGroup from '../../private/InputGroup/props';
import Collapsible from '../../private/Collapsible';
import collapsible from '../../private/Collapsible/props';
import config from './config.json';

export interface CollapsibleSwitchFilterHandle {
  setActiveIndex: (index: number) => void;
}

const CollapsibleSwitchFilter = forwardRef<CollapsibleSwitchFilterHandle, CollapsibleSwitchFilterProps>((props, ref) => {
  const [isChecked, setChecked] = useState(0);

  useImperativeHandle(ref, () => ({
    setActiveIndex: (index: number) => {
      setChecked(index);
    }
  }));
  return (
    <div className={classNames('collapsibleWrapper', style)}>
      <Collapsible {...collapsibleProps(props.header, props.isOpen, props.onOpen)}>
        <div className={classNames('collapsibleSwitchFilter', style)}>
          <InputGroup { ...switcherProps(props.switcher, isChecked, setChecked) } />
        </div>
      </Collapsible>
    </div>
  );
});
CollapsibleSwitchFilter.displayName = 'CollapsibleSwitchFilter';

const collapsibleProps = (header: string, isOpen = false, onOpen?: (state: boolean) => void): collapsible => ({
  ...config.Collapsible,
  header: header,
  isOpen,
  onOpen,
});

const switcherProps = (switcher: Switcher, isChecked: number, setChecked: any): inputGroup => ({
  ...config.InputGroup,
  items: switcher.items.map((item, index) => ({
    Input: {
      classNames: config.Input.classNames,
      Label: {
        hidden: config.Input.Label.hidden,
        text: item.text,
      },
      Link: {
        text: item.text,
        url: item.url,
        onClick: (e) => {
          setChecked(index);
          item.onClick && item.onClick(e, item.value);
        },
        hyperlinkAttributes: {
          ...(item.nofollow && { rel: 'nofollow' }),
        }
      },
      id: item.id,
      name: item.name,
      defaultChecked: index === isChecked || item.defaultChecked,
    }
  }))
});

export default React.memo(CollapsibleSwitchFilter);
